import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { linksRouter } from "../../../config/RouterLink";
import { useDispatch, useSelector } from "react-redux";
//Antd
import { Col, Divider, Row, Typography, Button } from "antd";

/**Ant-design icons */
import { InfoCircleFilled, EnvironmentOutlined } from "@ant-design/icons";

/**Redux-Ducks */
import {
  obtenerSistemaINE,
  obtenerSistemaOPLE,
  obtenerConvocatorias,
} from "../../../redux/consultavacantes/sistemasDucks";

import { limpiarDatos } from "../../../redux/consultavacantes/consultaVacantesDucks";
import {
  cleanFunciones,
  cleanRequisitosINE,
  cleanObjetivosINE,
  cleanFuncionesINE,
  cleanRequisitos,
  cleanObjetivos,
} from "../../../redux/consultavacantes/descripcionpuestoDucks";

import { ObtenerfechaSeguimiento } from "../../../redux/postulaciones/postulacionesDucks";

const { Text } = Typography;

export const AprobadaPage = () => {
  const { nombreConcurso, nombreConvocatoria, idSistema, vacanteDetalle } =
    useSelector((state) => state.consultaVacantes);
  const { convocatorias } = useSelector((state) => state.sistemas);
  const { fechaSeguimiento } = useSelector((state) => state.postulacion);

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(obtenerSistemaINE());
    dispatch(obtenerSistemaOPLE());
    dispatch(ObtenerfechaSeguimiento());
  }, [dispatch]);

  useEffect(() => {
    dispatch(obtenerConvocatorias(idSistema));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idSistema]);

  //Se limpia el state de Consulta Vacantes
  useEffect(() => {
    return () => {
      dispatch(limpiarDatos());
      dispatch(cleanObjetivos({}));
      dispatch(cleanFunciones({}));
      dispatch(cleanRequisitos({}));
      dispatch(cleanObjetivosINE({}));
      dispatch(cleanFuncionesINE({}));
      dispatch(cleanRequisitosINE({}));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Postulaciones = () => {
    history.push(linksRouter.postulaciones);
  };

  const Vacantes = () => {
    history.push(linksRouter.vacanteslogin);
  };

  const estado = localStorage.getItem("estado");

  return (
    <>
      <div className="layout-content-public">
        <div>
          <Row style={{ marginBottom: "10px" }}>
            <Col span={24}>
              <Text style={{ fontSize: "28px", fontWeight: 400 }}>
                Mi Postulación
              </Text>
            </Col>
          </Row>

          <Row>
            <Col span={12}>
              <Row>
                <Col span={12}>
                  <Text style={{ fontSize: "16px", fontWeight: 400 }}>
                    Concurso
                  </Text>
                  <br />
                  {idSistema === 1 && (
                    <Text style={{ fontSize: "18px" }}>{nombreConcurso}</Text>
                  )}
                  {idSistema === 2 && (
                    <Text style={{ fontSize: "18px" }}>{nombreConcurso}</Text>
                  )}
                </Col>

                <Col span={12}>
                  <Text style={{ fontSize: "16px", fontWeight: 400 }}>
                    {" "}
                    Convocatoria{" "}
                  </Text>
                  <br />
                  {idSistema === 1 && (
                    <Text style={{ fontSize: "18px" }}>
                      {nombreConvocatoria}
                    </Text>
                  )}
                  {idSistema === 2 && (
                    <Text style={{ fontSize: "18px" }}>
                      {nombreConvocatoria}
                    </Text>
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={4}>{/*Imagen del lado izquierdo*/}</Col>
            <Col span={20}>
              <Text style={{ fontSize: "26px" }}>¡Excelente! </Text>
              <br />
              {idSistema === 1 && (
                <Text style={{ fontSize: "18px" }}>
                  Te has postulado para la plaza vacante del
                  cargo/puesto:&nbsp;&nbsp;
                  <b>{vacanteDetalle.nombretipo}</b>
                </Text>
              )}
              {idSistema === 2 && (
                <Text style={{ fontSize: "18px" }}>
                  Te has postulado para la plaza vacante en &nbsp;
                  <b>{vacanteDetalle.nombreestado}</b> del
                  cargo/puesto:&nbsp;&nbsp;
                  <b>{vacanteDetalle.denominacion}</b>
                </Text>
              )}
              <br />
              <br />
              <EnvironmentOutlined />
              <Text style={{ fontSize: "18px", fontWeight: 700 }}>
                Lugar preferente para desarrollar las etapas presenciales
              </Text>

              <br />
              <Text style={{ fontSize: "16px" }}>
                Seleccionaste {estado} para realizarlo.
              </Text>
            </Col>
          </Row>
          <Row>
            <Col offset={12} span={12}>
              <Row>
                <Col span={12}>
                  {convocatorias.maxPostulaciones === "1" ? (
                    <Button
                      style={{
                        borderRadius: "7px",
                        fontSize: "18px",
                        height: "100%",
                        width: "90%",
                      }}
                      htmlType="submit"
                      onClick={Vacantes}
                      disabled={true}
                    >
                      Ir a vacantes
                    </Button>
                  ) : (
                    <Button
                      style={{
                        borderRadius: "7px",
                        fontSize: "18px",
                        height: "100%",
                        width: "90%",
                      }}
                      htmlType="submit"
                      onClick={Vacantes}
                    >
                      Ir a vacantes
                    </Button>
                  )}
                </Col>
                <Col span={12}>
                  <Button
                    style={{
                      borderRadius: "7px",
                      fontSize: "18px",
                      height: "100%",
                      width: "90%",
                    }}
                    htmlType="submit"
                    onClick={Postulaciones}
                  >
                    Ver mis postulaciones
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text style={{ fontSize: "28px", fontWeight: 400 }}>
                Seguimiento
              </Text>
            </Col>
            <Divider id="titulo-divider" />
            <Col span={24}>
              <div className="alert-info">
                <InfoCircleFilled
                  style={{ color: "#91d5ff", fontSize: "34px" }}
                />
                &nbsp;&nbsp;
                <Text style={{ fontSize: "18px" }}>
                  <b>
                    Recuerda que del {fechaSeguimiento.diaInicio} al{" "}
                    {fechaSeguimiento.diaFin} de {fechaSeguimiento.mes} del{" "}
                    {fechaSeguimiento.year} tendrás que ingresar nuevamente al
                    sistema
                  </b>
                </Text>{" "}
                <Text style={{ fontSize: "18px" }}>
                  para confirmar tu asistencia al examen de conocimientos,
                  obtener tu folio de participación y descargar tu comprobante
                  de registro e inscripción. En caso de no hacerlo no podrás
                  presentar el examen de conocimientos.
                </Text>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
